import React, { useState, useEffect, Fragment } from 'react';
import AlertModal from '../../../../shared/components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollar } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const ReceiptAdmissionButtonUpdateFromPL = ({ services, idAdmision, Callback }) => {

    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState(null);

    useEffect(() => {
        console.log("servicesUpdating", services);
        console.log("servicesUpdatingIdAdmision", idAdmision);
    }, []);

    const updatePriceFromPriceList = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/cambiar-valores-servicios-listaprecios', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_admision: idAdmision,
                servicios: services
            })
        }).then(response => {
            if(response.status == 200)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(res => {
            setAlertMessageModal("Precios Actualizados con exito");
            setAlertColorModal("success");
            setAlerShowModal(true);
        }).catch((error) => {
            setAlertMessageModal("Ha ocurrido un error actualizando los precios");
            setAlertColorModal("danger");
            setAlerShowModal(true);
            console.error('Error:', error);
        });
    }

    const onOkModal = () => {
        switch (colorAlertModal) {
            case "success":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                Callback();
                break;
            case "warning":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                updatePriceFromPriceList();
                break;
            case "danger":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                break;
        }
    }

    const onToggleModal = () => {
        switch (colorAlertModal) {
            case "success":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                Callback();
                break;
            case "warning":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                break;
            case "danger":
                setAlertMessageModal(null);
                setAlertColorModal(null);
                setAlerShowModal(false);
                break;
        }
    }

    return (
        <Fragment>

            <Tooltip title="Modificar precios de Servicios con base a la Lista de Precios Actual">
                <IconButton style={{ padding: 0 }} aria-label="upload picture" component="span"
                    onClick={() => {
                        setAlertMessageModal("Esta seguro de actualizar los Precios basados en la Lista de Precios");
                        setAlertColorModal("warning");
                        setAlerShowModal(true);
                    }}>
                    <FontAwesomeIcon icon={faDollar} />
                </IconButton>

            </Tooltip>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOkModal()}
                toggle={() => onToggleModal(false)}
            />
        </Fragment>
    );
};
export default ReceiptAdmissionButtonUpdateFromPL;
